import { Sun, Cloud, CloudRain, CloudSnow, CloudDrizzle, CloudFog, Zap, MapPin } from "lucide-react";

export const weatherIcon = (code, cls = "h-6 w-6") => {
  if (code === 0 || code === 1) return <Sun className={cls} />;
  if (code === 2 || code === 3) return <Cloud className={cls} />;
  if ([45, 48].includes(code)) return <CloudFog className={cls} />;
  if ([51, 53, 55, 56, 57].includes(code)) return <CloudDrizzle className={cls} />;
  if ([61, 63, 65, 66, 67, 80, 81, 82].includes(code)) return <CloudRain className={cls} />;
  if ([71, 73, 75, 77, 85, 86].includes(code)) return <CloudSnow className={cls} />;
  if ([95, 96, 99].includes(code)) return <Zap className={cls} />;
  return <Cloud className={cls} />;
};

export const WeatherWidget = ({ weather }) => {
  if (!weather || !weather.current) return null;
  const c = weather.current;
  return (
    <div data-testid="dashboard-weather-widget">
      <div className="flex items-center gap-1.5 text-sm text-muted-foreground mb-3">
        <MapPin className="h-4 w-4" />
        <span data-testid="weather-location">{weather.location_label}</span>
      </div>
      <div className="flex items-center gap-4">
        <div className="text-action">{weatherIcon(c.code, "h-12 w-12")}</div>
        <div>
          <div className="font-display text-4xl leading-none">{Math.round(c.temp)}{c.unit}</div>
          <div className="text-sm text-muted-foreground mt-1">{c.description} · feels {Math.round(c.feels_like)}{c.unit}</div>
        </div>
      </div>
      {weather.daily && (
        <div className="mt-5 flex gap-2 overflow-x-auto no-scrollbar">
          {weather.daily.slice(0, 7).map((d) => (
            <div key={d.date} className="flex flex-col items-center gap-1 rounded-xl bg-secondary/60 px-3 py-2 min-w-[56px]">
              <span className="text-[11px] text-muted-foreground">{new Date(d.date).toLocaleDateString(undefined, { weekday: "short" })}</span>
              <span className="text-good">{weatherIcon(d.code, "h-4 w-4")}</span>
              <span className="text-xs font-medium">{Math.round(d.temp_max)}°</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
